<script setup>
import {
    onBeforeUnmount,
    onMounted,
    ref,
    defineAsyncComponent,
    h,
    inject,
    markRaw,
} from 'vue';

const bus = inject('bus');

const modalData = ref(null);
const activeModals = ref([]);

function initModalsBus() {
    bus.on('modalShow', (data = null) => {
        modalData.value = data;
        const isTemplateActive = activeModals.value.some(({template}) => template === data.template);
        if (!isTemplateActive) {
            activeModals.value.push({
                ...data,
                component: markRaw(defineAsyncComponent(() => import(`@/components/ModalTemplates/${data.template}.vue`))),
            });
        }
    });

    bus.on('modalClose', (templateName = null) => {
        if (!templateName || !activeModals.value.length) {
            return;
        }

        activeModals.value = activeModals.value.filter(({template}) => template !== templateName);
    });
}

function isModalActive(modalData = null) {
    return modalData && !!Object.keys(modalData).length;
}

function renderModals() {
    return activeModals.value.map((item) => {
        return h(item.component, {
            isActive: isModalActive(item),
            modalData: item,
        });
    });
}

onMounted(() => {
    initModalsBus();
});

onBeforeUnmount(() => {
    bus.off('modalShow');
});
</script>

<template>
    <div class="modals-view">
        <Teleport to="body">
            <render-modals />
        </Teleport>
    </div>
</template>
